{
  "name": "@soldo/soldo-business-registration",
  "version": "7.2.0-dev",
  "description": "",
  "main": "index.js",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "lint": "npx eslint --ext .ts .",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json",
    "inject-tag": "sed -i -e \"s/%APP_VERSION%/$(git describe --tags)/\" ./dist/index.html",
    "bprod": "ng build --aot -c prod --named-chunks=true; npm run inject-tag",
    "bdemo": "ng build --aot -c demo --named-chunks=true; npm run inject-tag",
    "bpre": "ng build --aot -c preprod --named-chunks=true; npm run inject-tag",
    "bstag": "ng build --aot -c staging --named-chunks=true; npm run inject-tag",
    "bstaging01": "ng build --aot -c staging01 --named-chunks=true; npm run inject-tag",
    "bdev": "ng build --aot --named-chunks=true; npm run inject-tag",
    "prepatch": "npm version prepatch --preid=rc",
    "preminor": "npm version preminor --preid=rc",
    "rc": "npm version prerelease --preid=rc",
    "serveldev": "sudo ng serve --host registration-local.soldo.com --port 443 --ssl --ssl-key ./testreg.key --ssl-cert ./testreg.crt",
    "mockclient": "sudo ng serve --host registration-local.soldo.com --port 443 -c mock --proxy-config proxy.config.json --ssl --ssl-key ./testreg.key --ssl-cert ./testreg.crt",
    "mockserver": "DEBUG=express:* ; npx nodemon ./mock-server/index.mjs",
    "servelocal": "sudo ng serve --host registration-local.soldo.com -c staging --port 443 --ssl --ssl-key ./testreg.key --ssl-cert ./testreg.crt",
    "fakedev": "sudo ng serve --host registration-dev.soldo.com --port 443 --ssl --ssl-key ./testreg.key --ssl-cert ./testreg.crt",
    "fakestag": "sudo ng serve --host registration-stag.soldo.com -c staging --port 443 --ssl --ssl-key ./testreg.key --ssl-cert ./testreg.crt"
  },
  "keywords": [],
  "author": "Soldo Ltd",
  "private": false,
  "dependencies": {
    "@amplitude/analytics-browser": "^2.25.0",
    "@angular/animations": "^18.2.14",
    "@angular/common": "^18.2.14",
    "@angular/core": "^18.2.14",
    "@angular/forms": "^18.2.14",
    "@angular/platform-browser": "^18.2.14",
    "@angular/router": "^18.2.14",
    "@dynatrace/dtrum-api-types": "^1.319.3",
    "@intercom/messenger-js-sdk": "^0.0.20",
    "@ng-select/ng-select": "^13.9.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@types/google.maps": "^3.58.1",
    "core-js": "^3.45.1",
    "moment-mini": "^2.29.4",
    "ngx-cookie-service": "^18.0.0",
    "ngx-logger": "^5.0.12",
    "ngx-mask": "^20.0.3",
    "onfido-sdk-ui": "14.41.0",
    "round-flag-icons": "1.3.0",
    "rxjs": "^6.0.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.21",
    "@angular-devkit/core": "^18.2.21",
    "@angular/cli": "^18.2.21",
    "@angular/compiler": "^18.2.14",
    "@angular/compiler-cli": "^18.2.14",
    "@angular/language-service": "^18.2.14",
    "@angular/platform-browser-dynamic": "^18.2.14",
    "@playwright/test": "^1.56.1",
    "@types/node": "^12.11.1",
    "cors": "^2.8.5",
    "nodemon": "^3.1.10",
    "ts-node": "~3.2.0",
    "tslib": "^2.8.1",
    "typescript": "5.4.5",
    "url-polyfill": "^1.1.14",
    "webpack": "^5.101.3",
    "webpack-bundle-analyzer": "^4.9.1"
  }
}
